// extracted by mini-css-extract-plugin
export default {"wrapper":"bb2Qa","header":"DHoNq","title":"hAyG4","iconChevronRight":"kUFWc","button":"xKIgl","list":"lac9I","gallery":"ZPeiU","slide":"p5CYt","skelet":"us1Xr","cnScrollbar":"bizWM"};